import { ReactNode } from 'react';
import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";

import { ConfirmResult } from "@/@types/lib/confirmDialog";

interface IOptions {
  allowEscapeKey?: boolean;
  showCloseButton?: boolean;
  showConfirmButton?: boolean;
  html?: ReactNode | ReactNode[];
}

export default function confirm(
  title: string,
  text: string,
  type: string,
  confirmButtonText: string,
  cancelButtonText: string,
  options?: IOptions
): Promise<ConfirmResult> {
  return Swal.fire({
    title: title,
    text: text,
    html: options && options.html || "",
    icon: type,
    showCancelButton: true,
    cancelButtonText: cancelButtonText,
    confirmButtonText: confirmButtonText,
    showConfirmButton: options === undefined || options && options.showConfirmButton === undefined || options && options.showConfirmButton,
    allowOutsideClick: false,
    allowEscapeKey: options === undefined || options && options.allowEscapeKey === undefined || options && options.allowEscapeKey,
    keydownListenerCapture: true,
    showCloseButton: options === undefined || options && options.showCloseButton === undefined || options && options.showCloseButton,
    onClose: Swal.close()
  } as SweetAlertOptions)
    .then((result: SweetAlertResult) => {
      Swal.close();
      if (result.value) {
        return Promise.resolve({ confirmed: true } as ConfirmResult);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return Promise.reject({ confirmed: false } as ConfirmResult);
      } else {
        return Promise.reject({ canceled: true } as ConfirmResult);
      }
    })
    .catch((err) => {
      return Promise.reject({ error: true });
    });
}
